import { Controller } from "@hotwired/stimulus"

/**
 * ModalController - Maneja modales de Bootstrap con cierre automático tras operaciones exitosas
 * Conecta a data-controller="modal"
 */
export default class extends Controller {
  
  connect() {
    this.setupEventListeners()
  }
  
  disconnect() {
    this.removeEventListeners()
  }
  
  hide() {
    const modal = this.getModalInstance()
    if (modal) {
      modal.hide()
    }
    
    this.resetForm()
  }

  setupEventListeners() {
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)

    this.element.addEventListener('turbo:submit-end', this.boundHandleSubmitEnd)
  }
  
  removeEventListeners() {
    this.element.removeEventListener('turbo:submit-end', this.boundHandleSubmitEnd)
  }
  
  handleSubmitEnd(event) {
    const response = event.detail.fetchResponse
    
    if (response && response.response.ok) {
      // Pequeño delay para que se procese el Turbo Stream
      setTimeout(() => this.hide(), 100)
    }
  }
  
  getModalInstance() {
    return bootstrap.Modal.getInstance(this.element) || 
           new bootstrap.Modal(this.element)
  }

  resetForm() {
    const form = this.element.querySelector('form')
    if (form) {
      form.reset()
    }
  }
}
